import { operators as o, common as c } from '@pendo/aggregations';
import { PRODUCT_AREAS, SUB_PRODUCT_AREAS } from '@/utils/aggregation';

export default {
    name: 'ImpactBriefGuideMetricsAgg',
    productArea: PRODUCT_AREAS.IMPACT_BRIEF,
    subProductArea: SUB_PRODUCT_AREAS.ONBOARDING,
    responseFormat: 'row',
    build: ({
        guideIds,
        startOfPeriod,
        numDays,
        blacklist,
    }: {
        guideIds: string[];
        startOfPeriod: string;
        numDays: number;
        blacklist: c.BlacklistTypes;
    }) => {
        if (!guideIds) {
            throw new Error('guideIds is required for ImpactBriefGuideMetricsAggregation');
        }
        if (!startOfPeriod) {
            throw new Error('startOfPeriod is required for ImpactBriefGuideMetricsAggregation');
        }
        if (!numDays) {
            throw new Error('numDays is required for ImpactBriefGuideMetricsAggregation');
        }

        return o.pipeline(
            o.sources.guideEvents({
                appId: ['expandAppIds("*")'],
                blacklist,
                timeSeries: {
                    period: 'dayRange',
                    first: `${startOfPeriod}`,
                    count: -numDays,
                },
            }),
            o.identified('visitorId'),
            o.filter(`eventSubType(type) == "guideSeen" && guideSeenReason != "continue" && ${guideIds}`),
            o.group(
                ['guideId'],
                o.groupField('visitorCount', { count: 'visitorId' }),
                o.groupField('accountCount', { count: 'accountId' }),
                o.groupField('viewCount', { count: null }),
            ),
            o.reduce({
                sumViewCount: o.sum('viewCount'),
                sumVisitorCount: o.sum('visitorCount'),
                sumAccountCount: o.sum('accountCount'),
            }),
            o.evalExpression({
                id: '"impactBriefGuideMetricsAgg"',
            }),
        );
    },
};
